export default "__VITE_ASSET__B87i2TNy__"